import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

const words = ["AUTONOMOUS", "MARKETING.", "INFINITE", "SCALE."];

const lineVariants = {
  hidden: { y: "100%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 0.9, delay: 0.15 * i, ease: [0.16, 1, 0.3, 1] },
  }),
};

const HeroSection = ({ onTryDemo, onSeeMetrics }) => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden px-6 lg:px-12 pt-24">
      <div className="max-w-6xl w-full mx-auto text-center relative z-10">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-xs font-bold uppercase tracking-[0.3em] text-[#7C93B8] mb-6"
        >
          Skilmark — Your Autonomous Chief Marketing Officer
        </motion.p>

        <h1 data-testid={HOME.heroTitle} className="font-display font-black tracking-tighter leading-[0.9] text-5xl sm:text-6xl lg:text-8xl">
          {words.map((word, i) => (
            <span key={word} className="block overflow-hidden">
              <motion.span
                custom={i}
                initial="hidden"
                animate="visible"
                variants={lineVariants}
                className={`inline-block ${i === 1 || i === 3 ? "text-gradient-violet" : "text-white"}`}
              >
                {word}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          data-testid={HOME.heroSubtitle}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="mt-8 text-base sm:text-lg text-white/60 max-w-2xl mx-auto leading-relaxed"
        >
          One engine that formulates positioning, ASO metadata, viral video scripts, and
          $5/day test plans for your entire app portfolio — no ad budget required.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.7 }}
          className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <button
            data-testid={HOME.heroCtaDemo}
            onClick={onTryDemo}
            className="rounded-full bg-[#2563EB] text-white font-semibold px-8 py-4 text-sm tracking-wide hover:bg-[#3B82F6] transition-colors duration-300 shadow-[0_0_40px_-10px_rgba(37,99,235,0.7)]"
          >
            Generate My Campaign — Free
          </button>
          <button
            data-testid={HOME.heroCtaMetrics}
            onClick={onSeeMetrics}
            className="rounded-full border border-[#F97316]/40 text-white font-semibold px-8 py-4 text-sm tracking-wide hover:border-[#F97316] hover:bg-[#F97316] hover:text-white transition-colors duration-300"
          >
            See Tracked Metrics
          </button>
        </motion.div>
      </div>

      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/30 text-xs uppercase tracking-[0.3em]"
      >
        Scroll
      </motion.div>
    </section>
  );
};

export default HeroSection;
